// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Header } from 'semantic-ui-react';
import MaskedInput from 'react-text-mask';
import _ from 'lodash';
// local
// Views
import SaveUpdateModal from './SaveUpdateModal';
import PasswordLabel from 'app/ui/commons/PasswordLabel';
import CustomDropdown from 'app/ui/commons/CustomDropdown';
import ErrorLabel from 'app/ui/commons/ErrorLabel';
// libs
import t from 'app/lib/i18n';
import { CNPJ_MASK } from 'app/lib/masks';
import { _val, sortString } from 'app/lib/helper';
import { isValidCNPJ, isValidEmail, isValidPassowrd, isFormValid, removeReadOnly } from 'app/lib/formHelper';
// actions
import { ACTION } from 'app/redux/actions/modal';
import { create, update } from 'app/redux/actions/client';
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';

class ClientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: this.initForm(),
            errors: {},
            clientTypes: this.initClientTypes(),
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isOpened: isOpenedP } = this.props.modalSaveUpdate;
        const { isOpened: isOpenedN, action: actionN, data: dataN } = nextProps.modalSaveUpdate;

        if (!isOpenedP && isOpenedN) {
            const values = actionN === ACTION.UPDATE ? dataN : {};
            this.setState({ form: this.initForm(values), errors: {}, clientTypes: this.initClientTypes(values.type) });
        }
    }

    initForm(values = {}) {
        return {
            client: {
                id: _val(values.id, null),
                name: _val(values.name, ''),
                cnpj: _val(values.cnpj, ''),
                type: _val(values.type, null),
                status: _val(values.status, 0),
            },
            account: {
                name: '',
                email: '',
                password: '',
            },
        };
    }

    initClientTypes(type) {
        let types = Object.keys(CLIENT_TYPE);
        if (type !== CLIENT_TYPE.SALVUS) {
            types = types.filter(key => CLIENT_TYPE[key] !== CLIENT_TYPE.SALVUS);
        }
        types = types.map(key => {
            const value = CLIENT_TYPE[key];
            return {
                text: t(`client_type_${value}`),
                value,
            };
        });
        types.sort((a, b) => sortString(a.text, b.text));
        return types;
    }

    validateForm(form, field) {
        const errors = {};

        const name = form.client.name;
        if (!field || field === 'client.name') {
            if (_.isEmpty(name)) {
                errors['client.name'] = 'O campo nome é obrigatório.';
            } else {
                errors['client.name'] = undefined;
            }
        }

        const cnpj = form.client.cnpj;
        if (!field || field === 'client.cnpj') {
            if (_.isEmpty(cnpj)) {
                errors['client.cnpj'] = 'O campo CNPJ é obrigatório.';
            } else if (!isValidCNPJ(cnpj)) {
                errors['client.cnpj'] = 'O campo CNPJ não é válido.';
            } else {
                errors['client.cnpj'] = undefined;
            }
        }

        const type = form.client.type;
        if (!field || field === 'client.type') {
            if (!Object.values(CLIENT_TYPE).includes(type)) {
                errors['client.type'] = 'O campo tipo é obrigatório.';
            } else {
                errors['client.type'] = undefined;
            }
        }

        const { action } = this.props.modalSaveUpdate;
        if (action === ACTION.ADD) {
            const userName = form.account.name;
            if (!field || field === 'account.name') {
                if (_.isEmpty(userName)) {
                    errors['account.name'] = 'O campo nome é obrigatório.';
                } else {
                    errors['account.name'] = undefined;
                }
            }

            const password = form.account.password;
            if (!field || field === 'account.password') {
                const length = password.length;
                if (length === 0 || length < 8 || length > 20) {
                    errors['account.password'] = 'O campo senha não possui um tamanho adequado.';
                } else if (!isValidPassowrd(password)) {
                    errors['account.password'] = 'O campo senha não é válido.';
                } else {
                    errors['account.password'] = undefined;
                }
            }

            const userEmail = form.account.email;
            if (!field || field === 'account.email') {
                if (_.isEmpty(userEmail)) {
                    errors['account.email'] = 'O campo e-mail é obrigatório.';
                } else if (!isValidEmail(userEmail)) {
                    errors['account.email'] = 'O campo e-mail não é válido.';
                } else {
                    errors['account.email'] = undefined;
                }
            }
        }

        return errors;
    }

    onChange = field => (e, target) => {
        const { value } = target || e.target;
        let { form, errors } = this.state;
        _.set(form, field, value);
        const validation = this.validateForm(form, field);
        _.forIn(validation, function(value, key) {
            errors[key] = value;
        });
        this.setState({ form, errors });
    };

    hasError = field => !_.isEmpty(this.state.errors[field]);

    onConfirmModal = () => {
        // check if there is any error in the form
        const errors = this.validateForm(this.state.form);
        if (!isFormValid(errors)) {
            this.setState({ errors });
            // return false to not close the popup
            return false;
        }
        // if there are not errors, submit to the backend
        const { form } = this.state;
        const { action } = this.props.modalSaveUpdate;
        if (action === ACTION.ADD) {
            this.props.dispatch(create(form));
        } else if (action === ACTION.UPDATE) {
            const client = form.client;
            this.props.dispatch(update(client.id, client));
        }
        // return false to not close the popup
        return false;
    };

    render() {
        // props
        const { dispatch, modalSaveUpdate } = this.props;
        const options = {
            dispatch,
            title: 'Cliente',
            onConfirmModal: this.onConfirmModal,
            action: modalSaveUpdate.action,
            isOpened: modalSaveUpdate.isOpened,
            loading: modalSaveUpdate.loading,
            error: modalSaveUpdate.error,
        };
        // state
        const { form, errors, clientTypes } = this.state;
        return (
            <SaveUpdateModal id="clientModal" options={options}>
                <Form>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="Nome" error={errors['client.name']} />}
                            placeholder="Nome"
                            width={16}
                            value={form.client.name}
                            onChange={this.onChange('client.name')}
                            error={this.hasError('client.name')}
                            maxLength="80"
                            readOnly
                            onFocus={removeReadOnly}
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Input
                            label={<ErrorLabel label="CNPJ" error={errors['client.cnpj']} />}
                            control={MaskedInput}
                            mask={CNPJ_MASK}
                            placeholder="CNPJ"
                            type="text"
                            width={8}
                            value={form.client.cnpj}
                            onChange={this.onChange('client.cnpj')}
                            error={this.hasError('client.cnpj')}
                            readOnly
                            onFocus={removeReadOnly}
                        />
                        <CustomDropdown
                            label={<ErrorLabel label="Tipo" error={errors['client.type']} />}
                            placeholder="Tipo"
                            selection
                            width={8}
                            options={clientTypes}
                            value={form.client.type}
                            onChange={this.onChange('client.type')}
                            error={this.hasError('client.type')}
                            disabled={form.client.type === CLIENT_TYPE.SALVUS}
                        />
                    </Form.Group>
                    {modalSaveUpdate.action === ACTION.ADD && (
                        <div>
                            <Header as="h5">Administrador</Header>
                            <Form.Group>
                                <Form.Input
                                    label={<ErrorLabel label="Nome" error={errors['account.name']} />}
                                    placeholder="Nome"
                                    width={16}
                                    value={form.account.name}
                                    onChange={this.onChange('account.name')}
                                    error={this.hasError('account.name')}
                                    maxLength="80"
                                    readOnly
                                    onFocus={removeReadOnly}
                                />
                            </Form.Group>
                            <Form.Group>
                                <Form.Input
                                    label={<ErrorLabel label="E-mail" error={errors['account.email']} />}
                                    placeholder="E-mail"
                                    width={8}
                                    value={form.account.email}
                                    onChange={this.onChange('account.email')}
                                    error={this.hasError('account.email')}
                                    maxLength="255"
                                    readOnly
                                    onFocus={removeReadOnly}
                                />
                                <Form.Input
                                    label={<ErrorLabel label={<PasswordLabel />} error={errors['account.password']} />}
                                    placeholder="Senha"
                                    type="password"
                                    width={8}
                                    value={form.account.password}
                                    onChange={this.onChange('account.password')}
                                    error={this.hasError('account.password')}
                                    maxLength="20"
                                    readOnly
                                    onFocus={removeReadOnly}
                                />
                            </Form.Group>
                        </div>
                    )}
                </Form>
            </SaveUpdateModal>
        );
    }
}

ClientModal.propTypes = {
    auth: PropTypes.object,
    modalSaveUpdate: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    modalSaveUpdate: state.modalSaveUpdate,
});
export default connect(mapStateToProps)(ClientModal);
